import(/* webpackMode: "eager" */ "/workspace/web-admin/app/(auth)/login/page.tsx");
